import styled from "@emotion/styled";
import { Flex } from "@radix-ui/themes";

import { theme } from "@themes/themes";

import { Button, Text, ToggleGroupItem } from "@src/ui-kit";

export const TradeboxContainer = styled(Flex)`
  padding: 12px;
  width: 100%;
  height: 100%;
  border: 1px solid ${theme.color("gray-6")};
  border-radius: 8px;
  background: ${theme.color("gray-2")};

  &[data-hide-container="true"] {
    border: none;
  }

  overflow: auto;
`;

export const HeaderSection = styled(Flex)`
  gap: 8px;
  padding: 4px 0;
`;

export const DirectionToggleWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;

export const LeverageWrapper = styled(Flex)`
  gap: 4px;
  align-items: center;
`;

export const OrderTypeSection = styled.div`
  width: 100%;
`;

export const InputsSection = styled(Flex)`
  padding: 4px 0;
`;

export const SliderSection = styled.div`
  width: 100%;
  padding: 8px 0;
`;

export const MarginButton = styled(Button)`
  border-radius: 8px;
  height: 34px;
  min-width: 60px;
`;

export const CloseModalButton = styled(Button)`
  width: 34px;
  height: 34px;
  border-radius: 4px;
  border: 1px solid ${theme.color("gray-5")};
  background: ${theme.color("gray-2")} !important;
`;

export const ValueText = styled(Text)`
  ${theme.font.body12};
  color: ${theme.color("accent-contrast")};

  & > span {
    color: ${theme.color("gray-11")};
  }
`;

export const ConnectButtonStyled = styled(Button)`
  border-radius: 8px;
`;

export const ToggleGroupItemColored = styled(ToggleGroupItem)`
  ${theme.font.body12};

  &[data-state="on"] {
    &[data-color-value="long"] {
      background: ${theme.color("green-weak")};
      border: 1px solid ${theme.color("green-strong")};
    }

    &[data-color-value="short"] {
      background: ${theme.color("red-weak")};
      border: 1px solid ${theme.color("red-strong")};
    }
  }
`;

export const ToggleGroupOrderTypeItem = styled(ToggleGroupItem)`
  ${theme.font.body12};

  height: 32px;

  &[data-state="off"] {
    color: ${theme.color("gray-11")};
  }
`;
